import styled from "styled-components";

import { QueryBarItemImage } from "@similarweb/ui-components";

export const QueryBarItemImageStyled = styled(QueryBarItemImage)`
    display: inline-flex;
    width: 24px;
    height: 24px;
    margin: 8px;
`;
